import { useEffect } from 'react'

// eslint-disable-next-line
const useDidMount = (f: any) => useEffect(() => { f() }, [])

export default useDidMount
